/**
 * ADM-ADD-ROLE-BUTTON.WIDGET
 * Button to add a new role
 */

import { useState } from "react"
import { faPlus } from "@fortawesome/free-solid-svg-icons"
import { WithTranslation, withTranslation } from "react-i18next"
import Button from "@/components/button"
import { User, UserState } from "@/redux/user.types"
import SearchUser from "@/components/search-user"
import AdmEditUserModal from "@/modals/adm-edit-user.modal"
import { Session } from "@/redux/_session.types"
import { connect } from "react-redux"
import { store } from "@/core/root-reducer"
import { userActivate, userEditAndUpdateRole, userGet, userStatus, userUpdateRole } from "@/redux/user.actions"
import { STATUS_SAVED, STATUS_SAVING } from "@/redux/_status.types"
import SelectPopulationsModal from "@/modals/select-populations.modal"
import { Population } from "@/redux/population.types"

interface StateProps {
  _session: Session
  user: UserState
}

type Props = StateProps & WithTranslation

function AdmAddRoleWidget(props: Props) {
  const { t } = props

  //Modal to display
  const [currentModal, setCurrentModal] = useState<"MODAL_ADD_USER" | "MODAL_SELECT_POPULATIONS" | null>(null)

  //Display search user menu
  const [isSearchUserActive, setIsSearchUserActive] = useState(false)

  //Select specific user
  //Depending of the selected item, add straight to the list or open model
  async function selectUser(user: User) {
    user.role = props._session.selectedRole
    store.dispatch(userActivate(user))
    if (props._session.selectedRole === "ADMIN") {
      setCurrentModal(null)
      saveUser(user)
    } else {
      setCurrentModal("MODAL_SELECT_POPULATIONS")
    }
  }

  //Save user in BDD
  async function saveUser(user: User) {
    store.dispatch(userStatus(STATUS_SAVING))
    const response: any = await store.dispatch(userUpdateRole(user))
    store.dispatch(userStatus(STATUS_SAVED))
    if (!response.error) {
      store.dispatch(userGet([user].concat(props.user.list)))
    }
  }

  return (
    <div className="rel">
      {currentModal === "MODAL_ADD_USER" && (
        <AdmEditUserModal onClose={() => setCurrentModal(null)} onNext={(user) => selectUser(user)} />
      )}

      {currentModal === "MODAL_SELECT_POPULATIONS" && (
        <SelectPopulationsModal
          excludedFilters={[]}
          isWithoutDefaultFilters
          isSurveyFiltersIncluded
          isAccountSelectable
          onClose={() => setCurrentModal(null)}
          selectedPopulations={[]}
          onNext={(populations: Population[], excludedFilters) =>
            store.dispatch(
              userEditAndUpdateRole(props.user.active, props._session.selectedRole, populations, excludedFilters)
            )
          }
          title={t("roles_select_populations", {
            name: props.user.active.username
          })}
        />
      )}

      <Button
        icon={faPlus}
        className="primary"
        onClick={() => setIsSearchUserActive(true)}
        isLoading={props.user.status === STATUS_SAVING}>
        {t("roles_add")}
      </Button>

      {
        /** context menu rechercher des utilisateurs */
        isSearchUserActive && (
          <SearchUser
            activeUsers={props.user.list}
            onAdd={() => setCurrentModal("MODAL_ADD_USER")}
            onClose={() => setIsSearchUserActive(false)}
            onSelect={(user: User) => selectUser(user)}
          />
        )
      }
    </div>
  )
}

const mapStateToProps = (state) => ({
  _session: state._session,
  user: state.user
})

export default connect(mapStateToProps)(withTranslation()(AdmAddRoleWidget))
